import { render, staticRenderFns } from "./communityCard.vue?vue&type=template&id=4cce0f64&scoped=true"
import script from "./communityCard.vue?vue&type=script&lang=js"
export * from "./communityCard.vue?vue&type=script&lang=js"
import style0 from "./communityCard.vue?vue&type=style&index=0&id=4cce0f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cce0f64",
  null
  
)

export default component.exports